import { ValidationProvider } from 'vee-validate'
import DDiv from '@/components/Common/DDiv'

export default {
  components: {
    ValidationProvider,
    DDiv,
  },
  props: {
    value: {
      default: null,
    },
    placeholder: {
      default: null,
    },
    label: {
      default: '',
    },
    description: {
      default: '',
    },
    rules: {
      default: '',
    },
    validateName: {
      default: null,
    },
    className: {
      default: '',
    },
    disabled: {
      default: false,
      type: Boolean
    }
  },
  computed: {
    requiredClass() {
      return this.isRequired ? 'text-danger' : 'text-muted'
    },
    requiredName() {
      return this.isRequired ? '*' : '(Optional)'
    },
    isRequired() {
      return this.rules.includes('required')
    },
    currentComponent() {
      return this.rules ? ValidationProvider : DDiv
    },
  },
  methods: {
    inputChange(value) {
      this.$emit('input', value)
    },
  },
}
